// Classification options for trusses (structural type only — UDOMI-1019)
export const CLASSIFICATION_OPTIONS = ['Standard', 'Class 1', 'Monoslope'] as const;

export type Classification = (typeof CLASSIFICATION_OPTIONS)[number];

// Roof pitch options (1:12 to 12:12) — UDOMI-1030 raises max to 12:12
export const ROOF_PITCH_OPTIONS = [
  '1:12',
  '1.5:12',
  '2:12',
  '2.5:12',
  '3:12',
  '3.5:12',
  '4:12',
  '4.5:12',
  '5:12',
  '5.5:12',
  '6:12',
  '6.5:12',
  '7:12',
  '7.5:12',
  '8:12',
  '8.5:12',
  '9:12',
  '9.5:12',
  '10:12',
  '10.5:12',
  '11:12',
  '11.5:12',
  '12:12',
] as const;

export type RoofPitch = (typeof ROOF_PITCH_OPTIONS)[number];

// Overhang types
export const OVERHANG_TYPES = ['Standard', 'Custom'] as const;
export type OverhangType = (typeof OVERHANG_TYPES)[number];

// Inch options for truss size (0 to 11.5 in 0.5 increments)
export const INCH_OPTIONS: number[] = [];
for (let i = 0; i <= 23; i++) {
  INCH_OPTIONS.push(i * 0.5);
}

// Quantity options (1 to 999)
export const generateQuantityOptions = (): number[] => {
  const options: number[] = [];
  for (let i = 1; i <= 999; i++) {
    options.push(i);
  }
  return options;
};

// Custom overhang size options (0 to 24 inches)
export const OVERHANG_SIZE_OPTIONS: number[] = [];
for (let i = 0; i <= 24; i++) {
  OVERHANG_SIZE_OPTIONS.push(i);
}
